import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.colorPalette.green_90,
    padding: theme.spacing(6, 0, 6, 0),
    borderTop: `2px solid ${theme.onCardDivider.green_80}`,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  button: {
    display: 'flex',
    height: 36,
    width: 875,
    padding: '4px 16px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default makeStyles(styles);
